import {
  BookOpen,
  Activity,
  Clock,
  Send,
  Users,
  UserPlus,
  File,
  FileText,
  Star,
  Clipboard,
  CheckSquare,
  Tablet,
  Book,
  Map,
  Edit,
  Home,
  Tool,
  List,
} from "react-feather";


/*
const navItems = [
  {
    title: "Pages",
    pages: pagesSection,
  },
  {
    title: "Tools & Components",
    pages: componentsSection,
  },
  {
    title: "Plugins & Addons",
    pages: pluginsSection,
  },
];
*/

const pages = [
  {
    href: "/",
    icon: BookOpen,
    title: "Dashboard"
  },
  {
    href: "/tasks",
    icon: Clipboard,
    title: "Tasks",
  },
  // {
  //   href: "#",
  //   icon: ShoppingBag,
  //   title: "Documents"
  // },
  {
    href: "#",
    icon: Activity,
    title: "Practices",
    children: [

    ]
  }
  // {
  //   href: "/support",
  //   icon: Send,
  //   title: "Support"
  // },
];

const fppePages = [
  {
    href: "/fppetasks",
    icon: Clock,
    title: "Tasks",
  }
];

const communicationPages = [
  {
    href: "/messaging",
    icon: Send,
    title: "Messaging"
  },
  {
    href: "/messagingtemplates",
    icon: Edit,
    title: "Templates"
  },
]

const reportPages = [
  {
    href: "/reports/kpis",
    icon: Star,
    title: "KPIs"
  },
  {
    href: "/reports/roster",
    icon: List,
    title: "Rosters"
  },
  {
    href: "/reports/provider",
    icon: File,
    title: "Provider Reports"
  },
  {
    href: "/reports/practice",
    icon: FileText,
    title: "Practice Reports"
  },
  {
    href: "/reports/task",
    icon: Tablet,
    title: "Task Reports"
  },
  {
    href: "/reports/audit",
    icon: CheckSquare,
    title: "Audit Reports"
  },
]


const adminPages = [
  {
    href: "/admin/providers",
    icon: UserPlus,
    title: "Provider Mgmt."
  },
  {
    href: "/admin/practices",
    icon: Home,
    title: "Practice Mgmt."
  },
  {
    href: "/admin/users",
    icon: Users,
    title: "User Mgmt."
  },
  {
    href: "/admin/carriers",
    icon: Book,
    title: "Carrier Mgmt. (H3)"
  },
  {
    href: "/admin/locations",
    icon: Map,
    title: "Location Mgmt. (H3)"
  },
  {
    href: "/admin/revenueteams",
    icon: Tool,
    title: "Rev. Team Mgmt. (H3)"
  },
]

const navItems = [
  {
    title: "Enrollment",
    pages: pages
  },
  {
    title: "FPPE",
    pages: fppePages
  },
  {
    title: "Communication",
    pages: communicationPages
  },
  {
    title: "Reports & Analytics",
    pages: reportPages
  },
  {
    title: "Admin",
    pages: adminPages
  }

];

export default navItems;
